const IconOutlineSearch = (): JSX.Element => {
  return (
    <>
      <path
        fill="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeMiterlimit="4"
        strokeWidth="113.7778"
        stroke="#000"
        d="M959.999 959.999l-298.669-298.669M760.891 412.447c0 192.444-156.001 348.446-348.446 348.446s-348.446-156.001-348.446-348.446c0-192.444 156.002-348.446 348.446-348.446s348.446 156.002 348.446 348.446z"
      ></path>
    </>
  );
};

export default IconOutlineSearch;
